"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _signup = require('shared/enum/signup');








// Single source of truth for the product-interest cards. Consumed by the
// OrgSurvey ProductInterestForm (the multi-select picker) and by the
// OnboardingPayment offer (its value box mirrors the SMS card) so the two
// surfaces can never drift. Copy is phrased as first-person intents ("I want
// to…") rather than feature names.
 const SMS_PRODUCT_INTEREST_OPTION = {
  key: _signup.ProductInterest.SMS,
  iconSrc: '/assets/icons/pricing/sms-messaging-badge.svg',
  name: 'I want to text my patients',
  desc: 'Securely text patients and clients over SMS',
}; exports.SMS_PRODUCT_INTEREST_OPTION = SMS_PRODUCT_INTEREST_OPTION

 const PRODUCT_INTEREST_OPTIONS = [
  exports.SMS_PRODUCT_INTEREST_OPTION,
  {
    key: _signup.ProductInterest.TEAM_CHAT,
    iconSrc: '/assets/icons/pricing/team-communication-badge.svg',
    name: 'I want to communicate with my team',
    desc: 'Chat securely with your staff and coworkers in one place',
  },
  {
    key: _signup.ProductInterest.EXTERNAL_CHAT,
    iconSrc: '/assets/icons/pricing/team-badge.svg',
    name: 'I want to communicate with external organizations',
    desc: 'Message other clinics and organizations securely',
  },
]; exports.PRODUCT_INTEREST_OPTIONS = PRODUCT_INTEREST_OPTIONS
